<template>
    <button v-show="isVisible" @click="scrollToTop" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
    </button>
</template>

<script>
    export default {
        name: 'ScrollTop',
        data() {
            return {
                isVisible: false,
            };
        },
        methods: {
            handleScroll() {
                this.isVisible = window.scrollY > 200;
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll);
        },
        beforeUnmount() {
            window.removeEventListener("scroll", this.handleScroll);
        },
    };
</script>

<style scoped>
    .scroll-to-top {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #850A56;
        color: white;
        border: none;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        font-size: 24px;
        cursor: pointer;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        transition: opacity 0.3s ease-in-out;
    }

    .scroll-to-top:hover {
        background: #a31268;
    }
</style>